<template>
    <div>
        <h1 style="display: none;">{{ webmeta.og_title }}</h1>
        <div id="loading-mask" v-show="fly">
            <div class="loading-wrapper">
                <span class="loading-dot loading-dot-spin"><i></i><i></i><i></i><i></i></span>
            </div>
        </div>
        <div class='index' v-show="!fly">
            <!-- <button class="btn el_btn btn_addcart js_listing_cart_add" data-pid="1294892" type="button"
                                style="background-color: #F17C67;"><i class="icon-addcart"></i></button>
                            123123123 -->
            <Header class="h" />
            <!-- <div class="conts">测试</div> -->
            <!-- <keep-alive> -->
            <router-view class="r-v" />
            <!-- </keep-alive> -->
            <Footer class="f"></Footer>
        </div>
    </div>
</template>
<script>
import FacebookEventApi from '@/js/FacebookEventApi'
import { mapState } from 'vuex';
import Header from '@/components/header'
import Footer from '@/components/footer'
export default {

    components: {
        Header,
        Footer
    },
    data() {
        return {
            // datas: {
            //     itemid: '2704',
            //     number: '1'
            // },
            // id: '7',
            fly: true,
            webmeta: {
                meta_description: '',
                meta_keywords: '',
                og_description: '',
                og_image: '',
                og_title: '',
                og_url: '',
                icon: ''
            }
        };
    },
    async serverPrefetch() {
        const url = this.$ssrContext.clientUrl;
        // const url = 'https://ft-ec-waca.lytc.dev';
        const response = await this.$store.dispatch('header/getnav', url);
        this.webmeta = response;
        // this.webmeta = response.og;
        // this.webmeta = {
        //     "title": "【脆脆蔬】清脆爽口，每一口吃得到大自然的鮮甜味✨",
        //     "description": "【脆脆蔬】嚴選在地台灣蔬果🍋\n低卡好選擇👉️ https://crispy.hayoth.com/\n低溫烘焙✅ 香脆可口✅ 台灣蔬果✅\n保留蔬果營養成分✨原色原味🎉\n【脆脆蔬】給你涮嘴好滋味😋\n🚫無添加人工色素、香精、防腐劑\n嚴選產地直送，讓你吃得更安心💪",
        //     "url": "https://crispy.hayoth.com/",
        //     "image": "https://crispy.hayoth.com/api/get-image/867050516832821488257.jpg\t"
        // }
    },
    metaInfo() {
        // console.log(123);
        // console.log(this);
        return {
            title: this.webmeta.og_title,
            link: [
                {
                    rel: "icon",
                    type: "image/x-icon",
                    href: this.webmeta.icon,
                },
            ],
            meta: [
                { vmid: 'description', name: 'description', content: this.webmeta.meta_description },
                { vmid: 'keywords', name: 'keywords', content: this.webmeta.meta_keywords },
                { vmid: 'url', property: 'og:url', content: this.webmeta.og_url },
                { vmid: 'title', property: 'og:title', content: this.webmeta.og_title },
                { vmid: 'og_description', property: 'og:description', content: this.webmeta.og_description },
                { vmid: 'image', property: 'og:image', content: this.webmeta.og_image },
            ]
        }
    },
    computed: {
        // ...mapGetters('header',['isNavFetched'])
        ...mapState('header', ['website', 'ga_id', 'ga_state', 'ads', 'mc', 'getfb', 'isarticle']),
    },

    watch: {},
    methods: {
        async getcartLists() {
        },

    },

    created() {
       
    },
    mounted() {

        this.$store.dispatch('header/getnav').then(e => {
            // console.log(this.$store.getters["header/ga_state"]);
            if (this.$store.getters["header/ga_state"]) {
                let script1 = document.createElement('script');
                script1.async = true;
                script1.src = `https://www.googletagmanager.com/gtag/js?id=${this.ga_id}`;
                document.head.appendChild(script1);

                let script2 = document.createElement('script');
                script2.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                gtag('js', new Date());
                gtag('config', '${this.ga_id}');
                gtag('config', '${this.ads?.id}');
                gtag('event', 'conversion', {'send_to': '${this.ads?.browse}'});
            `;
                document.head.appendChild(script2);
                // Microsoft Clarity
                let script3 = document.createElement('script');
                script3.type = 'text/javascript';
                script3.innerHTML = this.mc;
                document.head.appendChild(script3);
                this.$store.commit('header/SET_GA_STATE', false)
            }
            this.fly = false;
            this.webmeta = e;
        });

        this.$store.dispatch('header/getwebsite').then(e => {
        });

        this.$store.dispatch("header/get").catch(e => {
        });
        this.$store.dispatch("header/getfb").then(() => {
            var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
            // var myFacebookEventApi = new FacebookEventApi('1507836200083222', 'EAAF5DmZB80TABO0bj1r0ZBTbJxgsoUM8GUJv8UhSKbGkZANxQWh4GvzejlhbU4fXVOExfBTnpRzywBk6ZAjlIBOIHRzJZBTHuLK703wmjnZCuBeLGesTvpSPOLoDmQVfFhnttzbfBjfXWSYqzSAUZAkhDDunpGZAOOK4yin4ISSCwxKMcYeV51mYx0ZCRPZBSMPzeDWMaiQr0oFAvR7OxHgZAnppZAm7GQpZA6h12GeDenaREHX9xiT38aIo46VSjsYmxYGbp5gZDZD');
            var fb_em = myFacebookEventApi.fbgetCookie('em');
            var fb_phone = myFacebookEventApi.fbgetCookie('phone');
            var fb_fn = myFacebookEventApi.fbgetCookie('fn');
            var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
            var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');

            myFacebookEventApi.callPageView(fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
        });
        this.$store.dispatch('cart/get').then(() => {
        });
        this.$store.dispatch('commodity/getall').then((e) => { });
    },
}
</script>
<style src="./loading.css" scoped></style>
<style lang='scss' scoped>
.index {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .r-v {
        flex-grow: 1;
        //  height: 100vh;
        // z-index: 19;

    }

    .h {
        z-index: 20;
    }

    .f {
        z-index: 19;
    }
}

@media only screen and (max-width: 992px) {
    .index {
        .f {
            z-index: 1;
        }
    }
}
</style>
